export const rakutenServicesActionTypes = {
    UPDATE_NEWSLETTER_REQUEST: 'UPDATE_NEWSLETTER_REQUEST',
    UPDATE_NEWSLETTER_SUCCESS: 'UPDATE_NEWSLETTER_SUCCESS',
    UPDATE_NEWSLETTER_FAILURE: 'UPDATE_NEWSLETTER_FAILURE',

    CANCEL_MEMBERSHIP_START: 'CANCEL_MEMBERSHIP_START',
    CANCEL_MEMBERSHIP_REQUEST: 'CANCEL_MEMBERSHIP_REQUEST',
    CANCEL_MEMBERSHIP_SUCCESS: 'CANCEL_MEMBERSHIP_SUCCESS',
    CANCEL_MEMBERSHIP_FAILURE: 'CANCEL_MEMBERSHIP_FAILURE',

    GET_AL_AND_NL_REQUEST: 'GET_AL_AND_NL_REQUEST',
    GET_AL_AND_NL_SUCCESS: 'GET_AL_AND_NL_SUCCESS',
    GET_AL_AND_NL_FAILURE: 'GET_AL_AND_NL_FAILURE',

    LOAD_SERVICES_CONFIG_REQUEST: 'LOAD_SERVICES_CONFIG_REQUEST',
    LOAD_SERVICES_CONFIG_SUCCESS: 'LOAD_SERVICES_CONFIG_SUCCESS',
    LOAD_SERVICES_CONFIG_FAILURE: 'LOAD_SERVICES_CONFIG_FAILURE',

    GO_TO_RAKUTEN_SERVICE: 'GO_TO_RAKUTEN_SERVICE',
};
